import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { getPermit, deletePermit } from "../../api/permit";
import TableCell from "../../components/common/ui/TableCell";
import FileList from "../../components/common/papers/FileList";
import { formatDate } from "../../utils/date";
import PageHeader from "../../components/common/ui/PageHeader";

export default function PermitViewPage() {
  const { id, permitId } = useParams();
  const navigate = useNavigate();

  const [permit, setPermit] = useState(null);
  const [loading, setLoading] = useState(true);

  const STATUS_LABELS = {
    planned: "계획",
    in_progress: "진행중",
    completed: "완료",
    delayed: "지연",
  };

  useEffect(() => {
    getPermit(permitId).then((data) => {
      setPermit(data);
      setLoading(false);
    });
  }, [permitId]);

  const handleDelete = async () => {
    if (!window.confirm("삭제하시겠습니까?")) return;
    await deletePermit(permitId);
    alert("삭제되었습니다.");
    navigate(`/project/${id}/permit/list`);
  };

  if (loading) return <div className="p-6 text-muted">불러오는 중...</div>;
  if (!permit) return <div className="p-6 text-muted">데이터가 없습니다.</div>;

  return (
    <div className="p-6 space-y-6">

      {/* 페이지 제목 */}
      <PageHeader showBack>인허가 상세</PageHeader>

      {/* 상단 버튼 */}
      <div className="flex justify-end gap-2">
        <Link
          to={`/project/${id}/permit/edit/${permitId}`}
          className="btn-edit"
        >
          수정
        </Link>
        <button onClick={handleDelete} className="btn-delete">
          삭제
        </button>
        <Link to={`/project/${id}/permit/list`} className="btn-basic">
          목록
        </Link>
      </div>

      {/* 기본 정보 */}
      <div className="page-box space-y-6">
        <div className="overflow-x-auto">
          <table className="min-w-full  text-sm">
            <colgroup>
              <col />
              <col style={{ width: "380px" }} />
            </colgroup>
            <tbody>
              <tr>
                <TableCell label="인허가명" value={permit.name || "-"} />
                <TableCell label="종류" value={permit.permit_type || "-"} />
              </tr>

              <tr>
                <TableCell label="발급기관" value={permit.authority || "-"} />
                <TableCell
                  label="상태"
                  value={STATUS_LABELS[permit.status] || "-"}
                />
              </tr>
            </tbody>
          </table>
        </div>

        {/* 날짜 정보 */}
        <div className="overflow-x-auto ">
          <table className="min-w-full border-collapse text-sm">
            <colgroup>
              <col />
              <col style={{ width: "380px" }} />
            </colgroup>
            <tbody>
              <tr>
                <TableCell
                  label="예정 접수일"
                  value={
                    permit.planned_submit_date
                      ? formatDate(permit.planned_submit_date)
                      : "-"
                  }
                />
                <TableCell
                  label="실제 접수일"
                  value={permit.submit_date ? formatDate(permit.submit_date) : "-"}
                />
              </tr>

              <tr>
                <TableCell
                  label="예정 완료일"
                  value={
                    permit.planned_date ? formatDate(permit.planned_date) : "-"
                  }
                />
                <TableCell
                  label="실제 완료일"
                  value={permit.actual_date ? formatDate(permit.actual_date) : "-"}
                />
              </tr>
            </tbody>
          </table>
        </div>

        {/* 첨부파일 */}
        <div className="p-4 border rounded-lg bg-gray-50">
          <div className="font-semibold mb-2">첨부파일</div>
          <FileList dns={permit.doc_dns} />
        </div>

        {/* 비고 */}
        <div className="overflow-x-auto ">
          <table className="min-w-full  text-sm">
            <tbody>
              <tr className="align-top">
                <TableCell
                  label="비고"
                  value={
                    permit.description ? (
                      <div className="whitespace-pre-wrap leading-relaxed">
                        {permit.description}
                      </div>
                    ) : (
                      "-"
                    )
                  }
                  colSpan={2}
                />
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
